<script>
  import {
  orgComputed,
  orgMethods
} from '@state/helpers';
export default {
  components: {},
  props: {
    route: {
      type: Object,
      required: false,
      default: () => {},
    },
  },
  data() {
    return {};
  },
  computed: {
    ...orgComputed,
    colors() {
      return {
        '--color':  this.primaryColor
      }
    }},
  mounted() {},
  methods: {
    ...orgMethods,
    getRouteTitle(route) {
      return typeof route.title === 'function' ? route.title() : route.title;
    },
  },
};
</script>

<template>
  <BaseLink v-if="route" tag="li" :to="route">
    <a :style="colors">{{ getRouteTitle(route) }}</a>
  </BaseLink>
</template>

<style lang="scss" scoped>
@import '@design';
// stylelint-disable selector-max-type
li {
  display: inline;

  &:not(:last-child) {
    margin-right: 3.2rem;
  }

  a {
    color: black;
    font-family: $roboto;
    font-size: 1.7rem;
    font-style: normal;
    font-weight: 500;
    line-height: 2.8rem;
    text-transform: capitalize;
  }
}
</style>
